import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import CommentPost from 'flarum/forum/components/CommentPost';
import PostControls from 'flarum/forum/utils/PostControls';
// "Modifier" right next to "Répondre" in a post's action bar, instead of
// only inside its "…" menu (core's PostControls.moderationControls(), the
// only place core offers it) - same conditions as core's own item, same
// action (the edit composer). Covers the discussion itself too: its text
// is its first post's.
//
// Removed from that "…" menu wherever the button is shown (a CommentPost),
// so it isn't offered twice.
export default function showEditNextToReply() {
  extend(CommentPost.prototype, 'actionItems', function (items) {
    const post = this.attrs.post;
    if (post.contentType() !== 'comment' || !post.canEdit() || post.isHidden()) return;

    // flarum/mentions' "Répondre" and flarum/likes' "J'aime" share the
    // default priority (shown in extension load order): "Répondre" is
    // lifted above this one so "Modifier" lands right after it.
    if (items.has('reply')) {
      items.setPriority('reply', 20);
    }
    items.add('edit', m(Button, {
      className: "Button Button--link",
      onclick: () => PostControls.editAction.call(post)
    }, app.translator.trans('core.forum.post_controls.edit_button')), 10);
  });
  extend(PostControls, 'moderationControls', function (items, post, context) {
    if (context instanceof CommentPost) {
      items.remove('edit');
    }
  });
}